if (!process.env.REACT_APP_API_URL) throw new Error('API_URL env variable is missing')

/** Base URL for API requests */
export const API_URL = process.env.REACT_APP_API_URL